import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { DataGridComponent } from '@sensika/ag-grid-kit';

/**
 * The grid's quick-search row (WAP-1728): `app-search-input` on its own row
 * under the toolbar, projected by the host into `<app-data-grid>`'s
 * `[belowToolbar]` slot. Owns the input; the query itself is the wrapper's
 * `quickSearchQuery()` (WAP-1739): Enter or the clear icon submits through
 * `setQuickSearchQuery()`, which purges the rows (DI, so the element must sit
 * inside `<app-data-grid>`). The host reads the wrapper's query when it builds
 * its request context - the query never enters the ag-grid filter model.
 * Declared in SensikaAgGridModule, not DataGridModule, because
 * `app-search-input` is a SharedModule component.
 */
@Component({
  selector: 'app-grid-quick-search',
  templateUrl: './grid-quick-search.component.html',
  styleUrls: ['./grid-quick-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GridQuickSearchComponent {
  /** i18n key of the placeholder (per view). */
  readonly placeholder = input.required<string>();

  private readonly grid = inject(DataGridComponent);

  readonly query = this.grid.quickSearchQuery;

  submit(value: string | null | undefined): void {
    this.grid.setQuickSearchQuery(value?.trim() ?? '');
  }

  /** Empties the input and refetches (a filter chip's remove). */
  clear(): void {
    this.submit('');
  }
}
